  
export const isExpired = (token) => {
      const expirationTime = new Date(token?.expires).getTime();
  return Date.now() / 1000 > expirationTime / 1000;
  };